import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import { z } from 'zod';

import { StringRequiredSchema } from '@/utils';

const ResetPasswordSchema = z
  .object({
    token: StringRequiredSchema('Token is required.'),
    password: StringRequiredSchema('Password is required.'),
    confirmPassword: StringRequiredSchema('Confirm Password is required.'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match.",
    path: ['confirmPassword'], // Show error on confirmPassword field
  });

export type ResetPasswordForm = z.infer<typeof ResetPasswordSchema>;

export const ResetPasswordDefaultValues: ResetPasswordForm = {
  token: '',
  password: '',
  confirmPassword: '',
};

export const useResetPasswordForm = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const form = useForm({
    defaultValues: { ...ResetPasswordDefaultValues, token },
    resolver: zodResolver(ResetPasswordSchema),
  });

  return form;
};
